import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-update-schedule-confirmation-dialog',
  templateUrl: './update-schedule-confirmation-dialog.component.html',
  styleUrls: ['./update-schedule-confirmation-dialog.component.scss']
})
export class UpdateScheduleConfirmationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UpdateScheduleConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Object) { }

  ngOnInit() {
  }

  public cancel() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

}
